import { createI18n } from "vue-i18n";
import zh from "./zh.json";
import en from "./en.json";

export const setupI18n = (languageStore) => {
  return createI18n({
    locale: languageStore.locale || "en", // 使用 Pinia 的语言状态
    fallbackLocale: "en",
    messages: {
      zh,
      en,
    },
  });
};
